/* import __COLOCATED_TEMPLATE__ from './conversations-enabled.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type HelpCenterSite from 'embercom/models/help-center-site';

interface Args {
  selectedHelpCenter: HelpCenterSite;
}

interface Signature {
  Args: Args;
}

export default class TicketsPortalConversationsEnabled extends Component<Signature> {
  @action
  toggleConversationsEnabled() {
    this.args.selectedHelpCenter.ticketsPortalConversationsEnabled =
      !this.args.selectedHelpCenter.ticketsPortalConversationsEnabled;
  }

  get isConversationsEnabled() {
    return this.args.selectedHelpCenter.ticketsPortalConversationsEnabled;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::Tickets::TicketsPortal::ConversationsEnabled': typeof TicketsPortalConversationsEnabled;
    'new-settings/helpdesk/tickets/tickets-portal/conversations-enabled': typeof TicketsPortalConversationsEnabled;
  }
}
